import { useMemo } from "react";
import style from "./Progress.module.css";
import clsx from "clsx";
import { RouterState, useRouterContext } from "../../services/router/routerContext";
import { useTranslation } from "react-i18next";

const ProgressDot: React.FC<{
    num: string,
    active: boolean,
    hasLine?: boolean
}> = ({ num, active, hasLine }) => {

    const dotClasses = clsx({
        [style.dot]: true,
        [style.active]: active
    });

    const line = useMemo( () => {

        if ( hasLine ) {

            const lineClasses = clsx({
                [style.line]: true,
                [style.active]: active
            });

            return <div className={lineClasses}></div>
        }

        return <></>

    }, [
        hasLine,
        active
    ] );

    return <>
        {line}
        <div className={dotClasses}>
            <span>{num}</span>
        </div>
    </>


}

export const Progress: React.FC = () => {


    const { state } = useRouterContext();

    const { t } = useTranslation();

    const stateName = useMemo( () => {

        switch ( state ) {
            case RouterState.EDITOR: return t( "draw_something_special" );
            case RouterState.COLOR: return t( "select_color" );
            case RouterState.COMMENT: return t( "about_you" );
        }

        return "Title";

    }, [state, t] );

    return <div className={style.container}>

        <div className={style.dots}>

            <ProgressDot num="I" active={state > 1} />
            <ProgressDot num="II" active={state > 2 } hasLine />
            <ProgressDot num="III" active={state > 3} hasLine />

        </div>

        <div className={style.title}>
            {stateName}
        </div>

    </div>



}